import React, { useState, useRef } from "react";
import { Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { clearMessage } from "../../actions/message";
import { getUsers, deleteUser } from "../../actions/user";
import UserModal from "./UserModal";
import { toast } from "react-toastify";
import "../../List.css";
import { Grid, IconButton, Button } from "@mui/material";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import ConfirmDialog from "../ConfirmDialog";
import { DataGridPro, GridActionsCellItem, GridToolbarExport, GridToolbarContainer } from '@mui/x-data-grid-pro';
import Filter from "../Filter";
import Paper from "@mui/material/Paper";

import TableContainer from "@mui/material/TableContainer";
import axios from "axios";
import { API_URL } from "../../services/api-uri";

const UserManagement = (props) => {

  const dispatch = useDispatch();

  const [USERS, SETUSERS] = useState([]);

  const { user: currentUser } = useSelector((state) => state.auth);
  const { users: listUsers } = useSelector((state) => state.users);
  const { message } = useSelector((state) => state.message);
  const [filter, setFilter] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [inactiveShow, setInactiveShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const [activeFilter, setActiveFilter] = useState(true);


  const [selectedUser, setSelectedUser] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);

  let userLoaded = false;
  const searchBarHelper = "Search for a user...";

  useEffect(() => {
    if (!userLoaded) {
      dispatch(getUsers())
        .then(() => {
          userLoaded = true;

          SETUSERS(ajouterParenthesesAuxDoublons(listUsers))

        })
        .catch(() => {
          setLoading(false);
        });
    }
  }, []);

  const ajouterParenthesesAuxDoublons = (prenoms) => {
    var compteur = {};
    var copiePrenoms = JSON.parse(JSON.stringify(prenoms));

    for (var i = 0; i < copiePrenoms.length; i++) {
      var prenom = copiePrenoms[i].firstName + " " + copiePrenoms[i].lastName;

      if (compteur[prenom]) {
        compteur[prenom]++;
        copiePrenoms[i].lastName = prenoms[i].lastName + " (" + compteur[prenom] + ")";
      } else {
        compteur[prenom] = 1;
      }
    }

    return copiePrenoms;
  }

  const handleSelectedUserChange = (u) => {
    setSelectedUser(u)
  }

  const updateActiveFilter = (e) => {
    setActiveFilter(e.target.checked);
  }

  const updateModalShow = (show) => {
    dispatch(clearMessage());
    setModalShow(show);
  };

  const updateSelectedUser = (u) => {
    dispatch(clearMessage());
    handleSelectedUserChange(u);
  };

  const add_user = () => {
    dispatch(clearMessage());

    updateModalShow(true);
    updateSelectedUser(null);
  };

  const edit_user = (show, uid) => {
    const user = listUsers.filter(user => { return user.id === uid })[0]
    if (user.id <= 0) { return; }

    dispatch(clearMessage());
    updateModalShow(show);
    updateSelectedUser(user);
  };

  function filterUsers(user) {
    if (user.id > 0) {
      if (!user.active && activeFilter) {
        return false
      }

      if (currentUser.type != 1 && user.idAgency != currentUser.idAgency) {
        return false
      }

      if (user.firstName && user.lastName) {
        return user.firstName.toLowerCase().includes(filter) || user.lastName.toLowerCase().includes(filter);
      } else {
        return true;
      }
    }
  }

  const exportUser = async () => {

    setLoading(true)

    try {
      const response = await axios.get(API_URL + `Users/exportUsers`, {
        responseType: 'blob',
      });
      const file = new Blob([response.data], {
        type: 'application/csv',
      });
      setLoading(false)
      const fileUrl = URL.createObjectURL(file);
      const anchor = document.createElement('a');
      anchor.href = fileUrl;
      anchor.download = `users.csv`;
      document.body.appendChild(anchor);
      anchor.click();

    } catch (error) {
      setLoading(false)
      toast.error(
        `An Error occured while downloading the file please try again later`,
        { autoClose: 750, position: toast.POSITION.BOTTOM_CENTER }
      );
      console.error(error);
    }
  };


  const HandleFilter = (e) => {
    setFilter(e.toLowerCase());
  };

  const getTextFromType = (val) => {
    switch (Number(val)) {
      case 1:
        return "Admin";
      case 2:
        return "Manager";
      case 3:
        return "Leader";
      case 4:
        return "Agent";
      default:
        return "";
    }
  };

  const columns = [
    { field: 'id', headerName: 'ID', hide: true },
    {
      field: 'actions',
      type: 'actions',
      sortable: false,
      getActions: (params) => {
        return [
          <>
            {currentUser.type == 1 && params.id > 0 && currentUser.id != params.id &&
              <>
                <IconButton aria-label="delete"
                  onClick={() => {
                    setConfirmOpen(true);
                    handleSelectedUserChange(params.id);
                  }}>
                  <DeleteIcon />
                </IconButton>
                <ConfirmDialog
                  title="Delete user ?"
                  content="Are you sure you want to delete this user ?"
                  open={confirmOpen}
                  setOpen={setConfirmOpen}
                  selectedUser={selectedUser}
                  onConfirm={(result) => {
                    if (result == true) {
                      dispatch(deleteUser(selectedUser))
                        .then(() => {
                          toast.success(
                            `user deleted successfuly`,
                            { autoClose: 750, position: toast.POSITION.BOTTOM_CENTER }
                          );
                        })
                        .catch(() => {
                          toast.error(
                            `An Error occured while deleting the user please try again later`,
                            { autoClose: 750, position: toast.POSITION.BOTTOM_CENTER }
                          );
                        });
                    }
                  }}>
                </ConfirmDialog></>}
          </>]
      }
    }
  ];


  const DataGrid = styled(DataGridPro)(({ theme }) => ({
    "& .MuiDataGrid-columnHeaders": { display: "none" },
    "& .MuiDataGrid-virtualScroller": { marginTop: "0!important" },
  }));

  const getTreeDataPath = (user) => {
    if (user.idAgency > 0) {
      return [user.idAgency == null ? "" : `${user.agencyName} (${listUsers.filter((u) => u.idAgency == user.idAgency && u.active).length})`, getTextFromType(user.type), user.fullName];
    }
    if (user.idCenter > 0) {
      return [user.idCenter == null ? "" : `${user.centerName} - Manager(s) (${listUsers.filter((u) => u.idCenter == user.idCenter && u.active).length})`, user.fullName];
    }
    if (user.type == 1) {
      return [`Admin (${listUsers.filter((u) => u.type == 1 && u.active).length})`, user.fullName];
    }
    if (user.type == null) {
      return [`Waiting for admin approval (${listUsers.filter((u) => u.type == null && u.active).length})`, `(${user.email})`];
    }
    else {
      return ["Free Agents", user.fullName + " " + user.id];
    }
  };

  const handleRowClick = (params) => {
    if (params.id > 0) {
      edit_user(true, params.id)
    }
  };

  return currentUser ? (
    <div className="app-container">
      <h1>Users management</h1>

      <Filter
        setSearchQuery={HandleFilter}
        searchQuery={filter}
        helper={searchBarHelper}
        setActive={updateActiveFilter}
        addDataFunction={add_user}
        HideAddButton={!(currentUser.type == 1 || currentUser.type == 3)}
      />

      {listUsers ?
        <TableContainer component={Paper}>

          <div style={{ height: "100%", width: '100%' }}>

            {currentUser.type == 1 ? <Button onClick={exportUser}>Export</Button> : <></>}
            <DataGrid

              hideFooter
              autoHeight="true"
              treeData
              onRowClick={handleRowClick}
              rows={
                ajouterParenthesesAuxDoublons(listUsers).filter(filterUsers).map((user) => {
                  user.fullName = `${user.firstName} ${user.lastName}`;
                  return user;
                })}
              columns={columns}
              getTreeDataPath={getTreeDataPath}
              initialState={{ pinnedColumns: { right: ['actions'] } }}
              groupingColDef={{ headerName: 'User', flex: 1, renderHeader: 0, hideDescendantCount: true, isGroupExpandedByDefault: "false" }}
              getRowClassName={(params) => {
                return !params.row.id ? `row-parent` : `row-child-${(listUsers.filter((u) => u.id == params.row.id)[0].active ? "active" : "inactive")}`
              }}

            />
          </div>
        </TableContainer>
        : <></>
      }

      <UserModal
        show={modalShow}
        currentUser={selectedUser}
        updateSelectedUser={() => { handleSelectedUserChange() }}
        onHide={() => updateModalShow(false)}
      />
    </div>
  ) : <></>;
};

export default UserManagement;
